import {
    DirectiveBinding,
    // watch
} from 'vue';

export default {
    name: 'focus',
    mounted(el: HTMLInputElement | Element, binding: DirectiveBinding) {
        const focusElement = () => {

            // if (!binding.value && binding.value != null) return;
            if (el instanceof HTMLInputElement) {
                el.focus();
                return;
            }
            const innerInput = el.querySelector('input');
            if (innerInput) {
                innerInput.focus();
            }
        };
        focusElement();

        // watch(() => binding.value, focusElement); // Watch for value changes
    },
}
